import { DefaultSeoProps } from 'next-seo'

export const SEO: DefaultSeoProps = {
  titleTemplate: '%s | MacSwap',
  defaultTitle: 'MacSwap - DEX on MA-Chain',
  description:
    'MacSwap - the leading DEX on MA-Chain. Swap tokens, provide liquidity, and earn yields in DeFi.',
  twitter: {
    cardType: 'summary_large_image',
    handle: '@MacSwap',
    site: '@MacSwap',
  },
  openGraph: {
    title: 'MacSwap - DEX on MA-Chain',
    description:
      'MacSwap - the leading DEX on MA-Chain. Swap tokens, provide liquidity, and earn yields in DeFi.',
    images: [{ url: 'https://assets.pancakeswap.finance/web/og/v2/hero.jpg' }],
  },
}
